<template>
  <v-slide-y-reverse-transition>
    <v-footer
      :fixed="true"
      class="pa-3"
      style="background-color:red;"
      v-show="isShowFooterCart && $vuetify.breakpoint.smAndDown"
    >
      <v-layout row align-center justify-center>
        <v-flex xs2 class="text-xs-left">
          <v-avatar size="25" color="red">
            <span class="white--text body-1">{{cartTotalQuantity}}</span>
          </v-avatar>
        </v-flex>
        <v-flex xs7 class="text-xs-center white--text body-1" @click="showCartDrawer(true)">View your cart</v-flex>
        <v-flex xs3 class="text-xs-right white--text body-1">Tk {{ cartTotalPrice }}</v-flex>
      </v-layout>
    </v-footer>
  </v-slide-y-reverse-transition>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import VueScrollTo from "vue-scrollto";

export default {
  name: "App",
  components: {},
  data() {
    return {
      // isOfferDialog: false,
    };
  },
  computed: {
    // ...mapState({
    //   // checkoutStatus: state => state.cart.checkoutStatus,
    //   // cartItems: state => state.cart.items,
    //   // serviceCategories: state => state.products.all,
    //   // isHomePageScrollToOrder: state => state.common.isHomePageScrollToOrder
    // }),
    ...mapGetters("cart", {
      cartProducts: "cartProducts",
      cartTotalPrice: "cartTotalPrice",
      cartTotalQuantity: "cartTotalQuantity",
      isShowFooterCart: "isShowFooterCart"
    })
  },
  methods: {
    ...mapActions("cart", ["showCartDrawer"])
    // onClickPackageLearnMore() {
    //   this.isPricingTableModal = true;
    // },
  },
  created() {
    // this.$store.dispatch("products/getAllProducts");
  },
  watch: {},
  mounted: function() {}
};
</script>